import { GameConstants } from "./GameConstants";
import { PreLoader } from "./states/Preloader";
import { GameState } from "./states/GameState";
import { Boot } from "./states/Boot";
import { GameVars } from "./GameVars";

export class Game extends Phaser.Game {

    constructor() {

        GameVars.gameHeight = GameConstants.GAME_HEIGHT;
        let height = GameVars.gameHeight;

        if (window.innerWidth === 667 && (window.innerHeight === 325 || window.innerHeight === 375)) {
            height += 100;
        }

        super(GameConstants.GAME_WIDTH, height, Phaser.CANVAS, "content", null, false, true);

        this.state.add("PreLoader", PreLoader, false);
        this.state.add("GameState", GameState, false);

        this.state.add("Boot", Boot, true);
    }
}
